import { object } from 'common/helpers'


export const initialState = {
  items: [],
}

export const setItems = (state, payload) => (
  object.set(state, 'items', payload)
)
